export default __webpack_public_path__ + "static/media/icon.calendar.2.8a866c6a.svg";